import GlobalNavbar from '../../components/feature/GlobalNavbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <GlobalNavbar />
      
      {/* Dark Hero Banner - matches other pages */}
      <section className="relative bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 pt-32 pb-16 px-6">
        <div className="max-w-[900px] mx-auto">
          <h1 className="text-4xl font-bold text-white mb-4">プライバシーポリシー</h1>
          <p className="text-sm text-gray-400">最終更新日：2026年2月</p>
        </div>
      </section>

      <main className="py-20">
        <div className="max-w-[900px] mx-auto px-8">
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. はじめに</h2>
              <p className="leading-relaxed">
                DOOHNUTS Inc.（以下「当社」といいます）は、当社のウェブサイトおよびサービスをご利用いただく皆様の個人情報の保護を重要な責任と考えております。
              </p>
              <p className="leading-relaxed mt-4">
                本プライバシーポリシーは、当社が取得する情報、その利用目的、管理方法、および利用者の権利について説明するものです。
              </p>
              <p className="leading-relaxed mt-4">
                本ポリシーは、適用される米国連邦法および州法に準拠することを目的としています。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. 取得する情報</h2>
              <p className="leading-relaxed mb-4">
                当社は、以下の情報を取得する場合があります。
              </p>
              
              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(1) 利用者が直接提供する情報</h3>
              <p className="leading-relaxed mb-3">
                お問い合わせフォームや申込手続き等を通じて提供される情報：
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>氏名</li>
                <li>会社名（該当する場合）</li>
                <li>メールアドレス</li>
                <li>電話番号</li>
                <li>物件情報または看板情報</li>
                <li>広告予算、キャンペーン内容</li>
                <li>その他任意で提供された情報</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(2) 通信情報</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>お問い合わせ内容</li>
                <li>当社とのやり取りの記録</li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">(3) 技術情報</h3>
              <p className="leading-relaxed mb-3">
                ウェブサイト利用時に自動的に取得される情報：
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IPアドレス</li>
                <li>ブラウザの種類</li>
                <li>デバイス情報</li>
                <li>アクセス日時</li>
                <li>閲覧ページ履歴</li>
                <li>Cookie等の技術を通じて取得される利用状況データ</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. 情報の利用目的</h2>
              <p className="leading-relaxed mb-4">
                当社は、取得した情報を以下の目的で利用します。
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>お問い合わせへの対応</li>
                <li>サービス提供および契約履行</li>
                <li>広告掲載およびパートナー業務の遂行</li>
                <li>サービス改善およびサイト最適化</li>
                <li>マーケティング情報の提供（配信停止可能）</li>
                <li>法令遵守および当社権利の保護</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. 情報の共有および開示</h2>
              <p className="leading-relaxed mb-4">
                当社は、個人情報を販売することはありません。
              </p>
              <p className="leading-relaxed mb-4">
                以下の場合に限り、情報を共有することがあります。
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>業務委託先（ホスティング会社、決済会社等）</li>
                <li>広告配信・運営パートナー（利用者の同意がある場合）</li>
                <li>法令に基づく開示要請があった場合</li>
                <li>事業譲渡、合併、買収等が発生した場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookieおよび類似技術</h2>
              <p className="leading-relaxed mb-4">
                当社は、ウェブサイトの利便性向上および利用状況分析のため、Cookieおよび類似技術を使用する場合があります。
              </p>
              <p className="leading-relaxed mb-4">
                これには、第三者のアクセス解析ツールが含まれることがあります。
              </p>
              <p className="leading-relaxed">
                利用者はブラウザ設定によりCookieを制御または拒否することができます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. 利用者の権利</h2>
              <p className="leading-relaxed mb-4">
                適用法令の範囲内において、利用者は以下の権利を有する場合があります。
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>当社が保有する個人情報へのアクセス請求</li>
                <li>誤った情報の訂正請求</li>
                <li>個人情報の削除請求</li>
                <li>マーケティング配信の停止</li>
                <li>一部の処理に対する異議申立て</li>
              </ul>
              <p className="leading-relaxed mt-4">
                権利行使をご希望の場合は、下記連絡先までご連絡ください。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. データの保存期間</h2>
              <p className="leading-relaxed mb-4">
                当社は、本ポリシーに記載された目的を達成するために必要な期間、個人情報を保持します。
              </p>
              <p className="leading-relaxed">
                法令上保持が必要な場合を除き、不要となった情報は安全に削除または匿名化します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. データの安全管理</h2>
              <p className="leading-relaxed mb-4">
                当社は、個人情報の不正アクセス、漏えい、改ざん、破壊を防止するため、合理的な技術的および組織的安全対策を講じています。
              </p>
              <p className="leading-relaxed mb-4">
                個人情報へのアクセスは、権限を付与された担当者に限定されます。
              </p>
              <p className="leading-relaxed">
                ただし、インターネット上の通信は完全な安全性を保証するものではありません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. 外部リンク</h2>
              <p className="leading-relaxed mb-4">
                当社サイトには第三者サイトへのリンクが含まれる場合があります。
              </p>
              <p className="leading-relaxed">
                当社は、外部サイトのプライバシー慣行について責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. 未成年者の情報</h2>
              <p className="leading-relaxed mb-4">
                当社のサービスは18歳未満の方を対象としていません。
              </p>
              <p className="leading-relaxed">
                当社は、未成年者から意図的に個人情報を収集することはありません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. 本ポリシーの変更</h2>
              <p className="leading-relaxed mb-4">
                当社は、本ポリシーを随時変更することがあります。
              </p>
              <p className="leading-relaxed mb-4">
                変更があった場合は、本ページ上で通知し、「最終更新日」を更新します。
              </p>
              <p className="leading-relaxed">
                変更後もサービスを利用した場合、変更に同意したものとみなします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. お問い合わせ先</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="font-semibold text-gray-900 mb-2">DOOHNUTS Inc.</p>
                <p className="text-gray-700">ネバダ州ラスベガス</p>
                <p className="text-gray-700">Email：info@doohnutsinc.com</p>
                <p className="text-gray-700">Phone：+1 (702) 477-9870</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
